import { Controller } from "react-hook-form";
import SelectDownArrowIconSVG from "../../assets/icons/svg/SelectDownArrowIconSVG";
import { useEffect, useState } from "react";
import { FontEnum } from "../../utils/enums/FontEnum";
import BaseHr from "../../components/Dividers/BaseHr";
import PlusIconSVG from "../../assets/icons/svg/PlusIconSVG";
import { OrderPartFormsEnum } from "../../../BuyerStack/utils/enums/OrderPartFormsEnum";


const ControllerSelectForUserCars = ({
    defaultValue,
    name,
    control,
    options,
    externalOnChange,
    setSelectedForm
}) => {
    const [loading, setLoading] = useState(true);
    const [selectedOption, setSelectedOption] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);


    useEffect(() => {
        try {
            if (defaultValue) {

                const selected = options.find((option) => option.id === defaultValue);

                if (selected) {
                    setSelectedOption(selected);
                };

            };
        }

        catch (error) {
            setSelectedOption(null);
        }

        finally {
            setLoading(false);
        };
    }, []);



    const getCarInfoDivString = (car) => {
        return `${car.Model.name} • ${car.Motor.name} • ${car.Generation.name} • ${car.vin}`;
    };

    const GetSelectableItem = (car, index, field) => {
        const handleOnClick = () => {
            field.onChange(car.user_car_id);
            externalOnChange(car)
            setSelectedOption(car);
            setDropdownOpen(false);
        };

        return (
            <div
                key={index}
                onClick={() => handleOnClick()}
                style={styles.selectableItemContainer}
            >
                <img
                    src={car.UserCarImages[0]}
                    style={styles.carImage?.small_car_image_url}
                />
                <div>
                    <p style={styles.carNameText}>
                        {car.title}
                    </p>

                    <p style={styles.carDescriptionText}>
                        {getCarInfoDivString(car)}
                    </p>
                </div>
            </div>
        );
    };

    const GetSelectedOptionBar = () => {
        return (
            <div style={styles.selectedItemContainer}>
                <img
                    src={selectedOption.image}
                    style={styles.carImage}
                />
                <div>
                    <p style={styles.carNameText}>
                        {selectedOption.name}
                    </p>

                    <p style={styles.carDescriptionText}>
                        {getCarInfoDivString(selectedOption)}
                    </p>
                </div>

                <SelectDownArrowIconSVG />
            </div>
        );
    };

    const GetUnselectedOptionBar = () => {
        return (
            <div style={styles.selectedOptionBar}>
                <p style={styles.placeholderText}>
                    Izaberite automobil
                </p>
                <SelectDownArrowIconSVG />
            </div>
        );
    };

    const GetAddCarListItem = () => {

        const handleAddUserCarClick = () => {
            setSelectedForm(OrderPartFormsEnum.ADD_CAR_FORM);
        }

        return (
            <div
                style={styles.selectableItemContainer}
                onClick={() => handleAddUserCarClick()}
            >
                <div style={styles.addCarButtonContainer}>
                    <PlusIconSVG />
                </div>

                <p style={styles.addCarText}>
                    Unesi novi automobil
                </p>

            </div>
        );
    };

    if (loading) {
        return null;
    };

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue ?? ""}
            render={({ field, fieldState }) => (
                <div style={styles.controller}>

                    <div onClick={() => setDropdownOpen((oldValue) => !oldValue)}>
                        {
                            selectedOption
                                ? GetSelectedOptionBar(selectedOption)
                                : GetUnselectedOptionBar()
                        }
                    </div>

                    {dropdownOpen && (
                        <div
                            {...field}
                            style={styles.dropdownContainer}
                        >
                            <div style={styles.selectableItemsContainer}>

                                <p style={styles.placeholderText}>
                                    Nedavno izabrani modeli
                                </p>

                                {options.map((option, index) => {
                                    return GetSelectableItem(option, index, field);
                                })}

                                <BaseHr />

                                {GetAddCarListItem()}

                            </div>
                        </div>
                    )}
                </div>
            )}
        />
    )
};


export default ControllerSelectForUserCars;

const styles = {
    selectedOptionBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingInline: 12,
        paddingTop: 6,
        paddingBottom: 6,
        border: "1px solid #0000003b",
        borderRadius: 6,
        width: "254px",
        cursor: 'pointer'

    },
    controller: {
        marginTop: 40
    },
    placeholderText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "#000000"
    },
    dropdownContainer: {
        width: 'max-content',
        marginTop: 10,
        border: "1px solid #0000003b",
        borderRadius: 6,
        paddingInline: 12,
        paddingTop: 10,
        paddingBottom: 10
    },
    selectableItemsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20
    },
    selectableItemContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer'
    },
    selectedItemContainer: {
        display: 'flex',
        width: 'max-content',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
        border: "1px solid #0000003b",
        borderRadius: 8,
        paddingInline: 12,
        paddingTop: 10,
        paddingBottom: 10
    },
    carImage: {
        width: "48px",
        height: "48px",
        border: "1px solid #0000003b",
        borderRadius: 8,
        objectFit: "cover"
    },
    carNameText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 600,
        color: "#000000"
    },
    carDescriptionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de"
    },
    addCarButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: "48px",
        height: "48px",
        border: "1px solid #0000003b",
        borderRadius: 8,
    },
    addCarText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#5B21B6"
    }
};
